import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { ServiceDetailPageContainer } from './ServiceDetailPage';
import { FaPaperPlane } from 'react-icons/fa';
import { motion } from 'framer-motion';
import emailjs from '@emailjs/browser';

const ServiceImage = styled.img`
  max-width: 200px; /* Smaller size */
  height: auto;
  border-radius: 0; /* Remove border-radius */
  margin: 0.5rem 0 1rem 2rem; /* Adjusted margin for text wrapping */
  box-shadow: none; /* Remove box-shadow */
  float: right; /* Allow text to wrap around */

  @media (max-width: 768px) {
    float: none;
    margin: 1rem auto;
    max-width: 80%;
    display: block;
  }
`;

const ContactSection = styled.section`
  padding: 4rem 2rem;
  background: linear-gradient(45deg, #00B4DB, #007bff);
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 250px;
  color: white;
  position: relative;
  overflow: hidden;
  margin-top: 8rem;
  border-radius: 20px;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 30%;
    height: 100%;
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.15), transparent);
    transform: skewX(-20deg) translateX(30%);
    transform-origin: top right;
    pointer-events: none;
    z-index: 0;
  }
`;

const ContactContent = styled.div`
  position: relative;
  z-index: 1;
  max-width: 600px;
  width: 100%;
`;

export const ContactTitle = styled.h2`
  color: #fff !important;
  margin-top: 0 !important;
`;

const ContactForm = styled.form`
  display: flex;
  gap: 1rem;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
`;

const ContactInput = styled.input`
  padding: 1rem 1.5rem;
  border: none;
  border-radius: 10px;
  font-size: 1rem;
  flex: 1;
  min-width: 200px;
  background: rgba(255, 255, 255, 0.9);
  color: #1f2937;

  &::placeholder {
    color: #6b7280;
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.5);
  }
`;

const SubmitButton = styled.button`
  background: #00B4DB;
  color: white;
  border: none;
  padding: 1rem 1.5rem;
  font-size: 1.2rem;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 180, 219, 0.2);

  &:hover {
    background: #007bff;
    transform: scale(1.02);
    box-shadow: 0 4px 12px rgba(0, 180, 219, 0.3);
  }

  svg {
    margin: 0;
  }
`;

function Photography() {
  const [formData, setFormData] = useState({
    name: '',
    phone: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    
    if (name === 'phone') {
      // Only allow numbers and limit to exactly 11 digits
      const numbersOnly = value.replace(/[^\d]/g, '');
      if (numbersOnly.length <= 11) {
        setFormData({
          ...formData,
          [name]: numbersOnly
        });
      }
    } else {
      setFormData({
        ...formData,
        [name]: value
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (formData.phone.length !== 11) {
      alert('Telefon numarası 11 haneli olmalıdır.');
      return;
    }

    try {
      const templateParams = {
        name: formData.name,
        phone: formData.phone,
        time: new Date().toLocaleString('tr-TR')
      };

      await emailjs.send(
        'service_771tgg7',
        'template_w676du8',
        templateParams,
        'xjG6_a9zdp6ZU1zHp'
      );

      alert('Başarılı');
      setFormData({ name: '', phone: '' });
    } catch (error) {
      alert('Bir hata oluştu');
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <ServiceDetailPageContainer>
      <h1>Profesyonel Fotoğraf Çekimi</h1>
      <p>Ürünleriniz ve hizmetleriniz için profesyonel fotoğraf çekimi hizmetleri sunuyoruz. Markanızın hikayesini en etkileyici şekilde anlatan görsellerle dijital varlığınızı güçlendiriyoruz.</p>

      <ServiceImage src="/media/demirer-ajans-1.png" alt="Fotoğraf Çekimi Görseli 1" />

      <h2>Neden Profesyonel Fotoğraf Çekimi Önemlidir?</h2>
      <p>Görsel içerik, günümüz dijital pazarlama stratejilerinin olmazsa olmazıdır. Yüksek kaliteli ve profesyonel fotoğraflar, ürünlerinizi ve hizmetlerinizi daha çekici hale getirerek müşterilerin ilgisini çeker, marka algınızı güçlendirir ve satışlarınızı artırır. İlk izlenim her zaman önemlidir ve görseller bu ilk izlenimi belirlemede kilit rol oynar.</p>

      <ServiceImage src="/media/demirer-ajans-2.png" alt="Fotoğraf Çekimi Görseli 2" />

      <h3>Hizmetlerimiz Neleri Kapsar?</h3>
      <ul>
        <li><b>Ürün Fotoğrafçılığı:</b> E-ticaret siteleri, kataloglar ve pazarlama materyalleri için yüksek çözünürlüklü ürün çekimleri.</li>
        <li><b>Kurumsal Fotoğrafçılık:</b> Şirket binaları, ofis ortamları, çalışan portreleri ve etkinlikler için profesyonel çekimler.</li>
        <li><b>Moda ve Yaşam Tarzı Fotoğrafçılığı:</b> Giyim, aksesuar ve yaşam tarzı ürünleri için stilize çekimler.</li>
        <li><b>Yiyecek ve İçecek Fotoğrafçılığı:</b> Restoranlar, kafeler ve gıda markaları için iştah açıcı görseller.</li>
        <li><b>Etkinlik Fotoğrafçılığı:</b> Konferanslar, seminerler, lansmanlar ve özel etkinlikler için kapsamlı fotoğraf hizmetleri.</li>
        <li><b>Konsept Çekimler:</b> Markanızın mesajını ve değerlerini yansıtan özgün ve yaratıcı konsept çekimler.</li>
        <li><b>Post-Prodüksiyon (Retouch):</b> Çekilen fotoğrafların renk düzeltme, rötuş ve diğer düzenlemelerle mükemmelleştirilmesi.</li>
      </ul>

      <h2>Görsel Hikayenizi Nasıl Anlatıyoruz?</h2>
      <ServiceImage src="/media/demirer-ajans-3.png" alt="Fotoğraf Çekimi Görseli 3" />
      <p>Her çekim öncesinde markanızın hedeflerini, hedef kitlenizi ve görsel kimliğinizi detaylı bir şekilde analiz ediyoruz. Çekim konseptini birlikte belirliyor, mekan seçimi, styling ve model yönlendirmesi gibi tüm süreçleri profesyonelce yönetiyoruz. Amacımız, markanızın hikayesini en etkileyici ve akılda kalıcı şekilde anlatacak görseller yaratmaktır.</p>
      <p>Dijital platformlarda rakiplerinizden sıyrılmak ve müşterilerinizin aklında yer etmek için bize güvenebilirsiniz.</p>

      <h2>Profesyonel Fotoğraf Çekimi Hizmetlerimiz</h2>
      <p>Profesyonel fotoğraf çekimi hizmetlerimiz, işletmenizin görsel kimliğini güçlendirmek için tasarlanmıştır. Deneyimli fotoğrafçılarımız, ürünlerinizi ve hizmetlerinizi en iyi şekilde yansıtacak görseller oluşturur.</p>
      <p>Modern ekipmanlar ve yaratıcı yaklaşımlarla, markanızın değerini artıracak fotoğraflar çekiyoruz. İşletmenizin dijital varlığını güçlendirmek için bize güvenebilirsiniz.</p>

      <ContactSection>
        <ContactContent>
          <ContactTitle>Sizi Arayalım</ContactTitle>
          <ContactForm onSubmit={handleSubmit}>
            <ContactInput 
              type="text" 
              name="name"
              placeholder="Adınız"
              value={formData.name}
              onChange={handleInputChange}
              required 
            />
            <ContactInput 
              type="tel" 
              name="phone"
              placeholder="Telefon Numaranız (11 Haneli)"
              value={formData.phone}
              onChange={handleInputChange}
              pattern="[0-9]*"
              inputMode="numeric"
              maxLength="11"
              minLength="11"
              required 
            />
            <SubmitButton
              type="submit"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <FaPaperPlane />
            </SubmitButton>
          </ContactForm>
        </ContactContent>
      </ContactSection>
    </ServiceDetailPageContainer>
  );
}

export default Photography; 